
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
	name: 'Maintenance',
	props: {
		visible: { type: Boolean, default: true },
		durationMinutes: { type: Number, default: 30 },
		dismissible: { type: Boolean, default: true },
	},
	setup(props, { emit }) {
		const close = () => emit('close')

		return {
			close,
		}
	},
})
